import basicInformationState from './basic-information/state';
import educationState from './education/state';
import languagesState from './languages/state';
import motivatorsState from './motivators/state';
import projectsState from './projects/state';
import skillsState from './skills/state';
import trainingsState from './trainings/state';
import workExperienceState from './work-experience/state';

export default {
  ...basicInformationState,
  ...workExperienceState,
  ...educationState,
  ...projectsState,
  ...languagesState,
  ...motivatorsState,
  ...skillsState,
  ...trainingsState,
  editProfileLoading: null,
  partHasChanges: {
    basic: null,
    experience: null,
    education: null,
    projects: null,
    trainings: null,
    skills: null,
    motivators: null,
    languages: null
  }
};
